export default {
  auth: () => import("/opt/buildhome/repo/layouts/auth.vue").then(m => m.default || m),
  dashboard: () => import("/opt/buildhome/repo/layouts/dashboard.vue").then(m => m.default || m),
  default: () => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m),
  partnership: () => import("/opt/buildhome/repo/layouts/partnership.vue").then(m => m.default || m)
}